/**
 *
 * @module deviceClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef DeviceClientEndpoint
 * @type {Object}
 *
 * @property {String} createDeviceGrant
 *
 */

/**
 *
 * @enum
 * @type {DeviceClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createDeviceGrant: null
});



// WEBPACK FOOTER //
// ./src/services/device/deviceClientEndpoint.js